import { render, staticRenderFns } from "./ApplyPurchaseList.vue?vue&type=template&id=589c9bce&"
import script from "./ApplyPurchaseList.vue?vue&type=script&lang=ts&"
export * from "./ApplyPurchaseList.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyPurchaseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports